<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="section">
    <div class="sectionHeader">
      <div class="header">
        <div class="title">
          <div class="label">
            {{'VEHICLE_MAP_VIEW.title' | translate}}
          </div>
          <div class="help">
          </div>
        </div>
      </div>
      <div class="inputSearch">
        <mat-radio-group aria-label="Select an option" [(ngModel)]='selectUnit' style = "display:flex;">
          <mat-radio-button style="padding: 0px 5px;" value="current_unit" [checked]="true"
            (click)="changeRadio('current_unit')">{{'VEHICLE.current_unit' | translate}}</mat-radio-button>
          <mat-radio-button value="all_units" (click)=" changeRadio('all_units');">{{'VEHICLE.all_units' | translate}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="buttons">
        <div class="button" routerLink="/spotDrivers">
          {{'HEADER.mySpotDriver' | translate}}
        </div>
      </div>
      <div class="buttons">
        <div class="button" (click)="resetMap()">
          {{'HEADER.reset_map' | translate}}
        </div>
      </div>
      <div class="refresh" (click)="refreshMapView()"><i class="material-icons refresh">refresh</i></div>
    </div>
    <div class="content">
      <div class="left">
        <div class="search">
          <input type="text" mat-input class="searchInput" [(ngModel)]="filterVehicle"
            (keyup)="searchFilter(filterVehicle, 'vehicle_number');" placeholder="Vehicle No.">
          <!-- <i class="material-icons" (click)="searchCleared = true;clearFilter();">cancel</i> -->
        </div>
        <div class="summaryBox">
          <div class="container">
            <div class="summary" [ngClass]="{'total-selected': total_selected}" (click)="total_selected = true;
                        on_shipment_selected = false;
                        free_selected = false;
                        selectedStatus = 'NA';
                        filterData();  ">
              <!-- getVehicles() -->
              <div class="status">
                {{'VEHICLE_MAP_VIEW.total' | translate}}
              </div>
              <div class="value">
                <!-- {{shipmentCounts.pending}} -->
                {{vehicle_stats.total}}
              </div>
            </div>
          </div>
        </div>
        <div class="drivers" *ngIf="vehicles_array && vehicles_array.length;else noVehilces">
          <div class="driver-card" *ngFor="let vehicle of vehicles_array;let i=index;"
            (click)="$event.stopPropagation();panToVehicle(vehicle)">
            <div class="driver-detail">
              <div class="material-icons"><img src="assets/truck-icon.svg" alt=""></div>
              <div class="detail">{{vehicle.vehicle.name}}</div>
              <div class="actionBtn" (click)='$event.stopPropagation();'>
                <div class="button">
                  <mat-select [placeholder]="'VEHICLE.action' | translate">
                    <mat-option (click)="$event.stopPropagation();openViewVehicle(vehicle);"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/View.svg" alt=""> {{'VEHICLE.view'
                      | translate}}</mat-option>
                    <!-- <mat-option *ngIf="vehicle.attached != ''"
                      (click)="$event.stopPropagation();openAttachDriverComponent(vehicle, 'Detach');"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/detach-driver.svg" alt="">
                      {{'VEHICLE.detachLab' | translate}}</mat-option>
                    <mat-option *ngIf="vehicle.attached == '' && !vehicle.maintenance"
                      (click)="$event.stopPropagation();openAttachDriverComponent(vehicle, 'Attach');"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/atach-driver.svg" alt="">
                      {{'VEHICLE.attachLab' | translate}}</mat-option> -->
                    <mat-option *ngIf="vehicle.attached == ''"
                      (click)="$event.stopPropagation();openEditDriver(vehicle);"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt="">
                      {{'VEHICLE.edit' | translate}}</mat-option>
                    <!-- <mat-option *ngIf="!vehicle.maintenance && (vehicle.trip_status != 'On Shipment')"
                      (click)="$event.stopPropagation();openMarkMaintainanceDialog(vehicle,'markIn');"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/in_maintenance.svg" alt="">
                      {{'VEHICLE.markInMaintainance' | translate}}</mat-option> -->
                    <!-- <mat-option *ngIf="vehicle.maintenance && (vehicle.trip_status != 'On Shipment')"
                      (click)="$event.stopPropagation();openMarkMaintainanceDialog(vehicle,'markOut');"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/in_use.svg" alt="">
                      {{'VEHICLE.markOutMaintainance' | translate}}</mat-option> -->
                    <mat-option (click)="$event.stopPropagation();openUploadDialog(vehicle);"> <img
                        style="width: 16px;position: relative;top: 3px;" src="assets/upload.svg" alt="">
                      {{'VEHICLE.upload' | translate}}</mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
            <div class="driver-detail">
              <div class="material-icons"></div>
              <div class="detail">
                {{vehicle.vehicleNumber}}
                <br>
                {{vehicle.carrier_name}} 
                <span *ngIf="vehicle.maintenance">
                  <img src="assets/VehicleMaintenance.svg" alt="" style="width: 20px;"
                    title="{{'VEHICLE.in_maintenance' | translate}}">
                </span>
                <span *ngIf="vehicle.usageIndicator_code"> ( {{vehicle.usageIndicator_code}} ) </span>
              </div>
              <div class="material-icons"></div>
              <div
                [ngClass]="{'in_shipment': vehicle.trip_status == 'In Shipment','on-duty': vehicle.trip_status == 'Attached','off-duty': vehicle.trip_status == 'Free'}">
                {{vehicle.trip_status}}</div>
            </div>
            <div class="driver-detail">
              <div class="material-icons"></div>
              <div class="detail">{{vehicle.shipper_unit}}</div>
            </div>
            <div class="driver-detail" style="margin-top: 30px;" *ngIf="vehicle.driverName">
              <div class="material-icons">account_circle</div>
              <div class="detail">{{vehicle.driverName}}</div>
              <div class="actionBtn">
                <div class="shipment-status inTransit">
                  {{vehicle.shipment_status}}
                </div>
              </div>
            </div>
            <div class="driver-detail" *ngIf="vehicle.driverMobile">
              <div class="material-icons">call</div>
              <div class="detail">{{vehicle.driverMobile}}</div>
            </div>
          </div>
        </div>
        <ng-template #noVehilces>
          <div class="drivers no-drivers">
            <span style="font-size: 18px; font-weight: bold;">
              {{'VEHICLE_MAP_VIEW.no_vehicles' | translate}}
            </span>
          </div>
        </ng-template>
      </div>
      <div class="right">
        <!-- <div class="mapButtons">
            <div class="submitButton" >
              <div class="button" style="width: 150px;"   [ngStyle]="{'background-color': allVehicles ? '#174072':'#fff' , 'color': allVehicles? '#fff' : '#000'}" (click)="allVehicles = true;vehiclesList = false ;getVehicles()">
                {{'VEHICLE_MAP_VIEW.all_drivers' | translate}}
              </div>
            </div>
            <div class="submitButton" >
                <div class="button"   [ngStyle]="{'background-color': vehiclesList ? '#174072':'#fff' , 'color': vehiclesList ? '#fff' : '#000'}" (click)="allVehicles = false;vehiclesList = true;getVehicles()">
                  {{'VEHICLE_MAP_VIEW.drivers_list' | translate}}
                </div>
            </div>
          </div> -->
        <div class="vehicleMap" id="vehicleMap"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #uploadDialog>
  <div class="dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          {{'VEHICLE.upload' | translate}}<i class="material-icons" (click)="uploadDocsRef.close();">clear</i>
        </div>
      </div>
      <div class="uploadFile">
        <input class="inputField" accept="image/*" (change)="fileChanged($event)" type="file">
      </div>
      <div class="imageTypes">
        (Only .png, .jpeg or JPG files)
      </div>
      <div class="submitButton">
        <div class="button" (click)="uploadRegDocs();">
          {{'VEHICLE.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #markMaintainance>
  <div class="dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          <span *ngIf="mark_type == 'markIn'">
            {{'VEHICLE.markInMaintainance' | translate}}
          </span>
          <span *ngIf="mark_type == 'markOut'">
            {{'VEHICLE.markOutMaintainance' | translate}}
          </span>
          <i class="material-icons" (click)="closeModal({});">clear</i>
        </div>
      </div>
      <div class="uploadFile">
        <div class="message" *ngIf="mark_type == 'markIn' && selected_vehicle_data.attached.length">
          {{'VEHICLE.markInMessage_attached' | translate}}
        </div>
        <div class="message" *ngIf="mark_type == 'markIn' && !selected_vehicle_data.attached.length">
          {{'VEHICLE.markInMessage' | translate}}
        </div>
        <div class="message" *ngIf="mark_type == 'markOut'">
          {{'VEHICLE.markOutMessage' | translate}}
        </div>
        <div *ngIf="mark_type == 'markOut'">
          <div class="label">
            {{'VEHICLE.maintainanceDueDate' | translate}}
          </div>
          <input class="inputField" [(ngModel)]="due_date_string" (dateChange)="getEpoch($event.value);"
            (click)="picker.open()" [matDatepicker]="picker" [min]="min_due_date" />
          <mat-datepicker #picker></mat-datepicker>
          <i class="material-icons calendar" style="font-size:18px;">date_range</i>
        </div>
      </div>
      <div *ngIf="showYesNo" class="submitButtonNo" (click)="closeModal({});">
        <div class="button">
          {{'CONFIRMMODAL.no' | translate}}
        </div>
      </div>
      <div *ngIf="showYesNo" class="submitButton" (click)="markMaintainanceSubmit();">
        <div class="button">
          {{'CONFIRMMODAL.yes' | translate}}
        </div>
      </div>
      <div *ngIf="!showYesNo" class="submitButton">
        <div class="button" (click)="markMaintainanceSubmit();">
          {{'CONFIRMMODAL.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>